import { IOffer, IOfferAction, OfferActionTypes } from '@models/winnerSelection/ITableDemand';
import { IListElement } from '@srm/ui/types/IListElement';
import { buildOfferMenuActions } from './buildOfferMenuActions';

/** KO-таблица поддерживает подмножество типов действий Demand-меню. */
const KO_ACTION_TYPES: ReadonlySet<OfferActionTypes> = new Set([
    OfferActionTypes.CustomForm,
    OfferActionTypes.DownloadAttachments,
    OfferActionTypes.OpenOffer,
]);

/**
 * Kebab-меню KO-таблицы: тот же builder, что у Demand, суженный до трёх типов.
 * Из модалок KO открывает только CustomForm и окно архива документации в фоне —
 * остальное (download / window.open) builder выполняет inline сам.
 */
export function buildOfferMenuActionsKO(
    offer: IOffer,
    tableKey: string,
    onCustomForm: (offer: IOffer, action: IOfferAction) => void,
    onAttachmentsArchive: (offer: IOffer, action: IOfferAction) => void,
): IListElement[] {
    return buildOfferMenuActions(
        offer,
        tableKey,
        (modal, modalOffer, action) => {
            if (modal === 'customForm' && action) onCustomForm(modalOffer, action);
            if (modal === 'attachmentsArchive' && action) onAttachmentsArchive(modalOffer, action);
        },
        KO_ACTION_TYPES,
    );
}
